function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Frame",
  clipPath: "url(#clip0_14045_5789)"
}, React.createElement("path", {
  id: "Vector",
  d: "M10.0753 2.1402L10.1379 2.19553L13.8046 5.8622C13.917 5.97518 13.9852 6.12469 13.9968 6.28362C14.0085 6.44255 13.9628 6.6004 13.8681 6.72856C13.7734 6.85672 13.6359 6.94672 13.4805 6.98224C13.3252 7.01776 13.1623 6.99646 13.0213 6.9222L10.9066 9.0362L9.95726 11.5675C9.93225 11.6343 9.89669 11.6967 9.85192 11.7522L9.80526 11.8055L8.80526 12.8055C8.69038 12.9202 8.5376 12.989 8.37558 12.9991C8.21357 13.0092 8.05345 12.9598 7.92526 12.8602L7.86192 12.8049L5.99992 10.9435L3.47126 13.4715C3.35128 13.5911 3.1903 13.6605 3.021 13.6657C2.8517 13.6709 2.68678 13.6114 2.55974 13.4994C2.43269 13.3873 2.35305 13.2312 2.33699 13.0625C2.32093 12.8939 2.36965 12.7255 2.47326 12.5915L2.52859 12.5289L5.05659 10.0002L3.19526 8.1382C3.08047 8.0234 3.01152 7.87067 3.00133 7.70865C2.99114 7.54664 3.04042 7.38647 3.13992 7.2582L3.19526 7.19553L4.19526 6.19553C4.24556 6.14505 4.30363 6.10296 4.36726 6.07087L4.43259 6.04287L6.96326 5.09287L9.07726 2.97953C9.00517 2.84475 8.98158 2.6893 9.01045 2.5392C9.03932 2.38911 9.11888 2.25349 9.23582 2.15506C9.35276 2.05664 9.49997 2.00139 9.65279 1.99856C9.80561 1.99573 9.95476 2.04617 10.0753 2.1402Z",
  fill: "#FDFF12"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0_14045_5789"
}, React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white"
})));

var SvgPinningRowActive = function SvgPinningRowActive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPinningRowActive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/PinningRowActive.a400e622.svg";
export { ForwardRef as ReactComponent };